module.exports = __webpack_public_path__ + "img/1459871893.e9f0d894.jpg";